import {Button, Modal} from 'antd'
import {host_getsbyOwner_api} from 'apis'
import {getId, getType} from 'apis/model/base'
import classNames from 'classnames'
import _ from 'lodash'
import Translate from 'modules/local/Translate'
import useTranslate from 'modules/local/useTranslate'
import {NavigationContext} from 'modules/navigation/NavigationContext'
import {useHistory} from 'modules/navigation/useRouter'
import React, {useCallback, useContext, useMemo, useState} from 'react'
import {useLocation} from 'react-router-dom'
import {useToggle} from 'react-use'
import {branch, compose, fromRenderProps, nest, pure, renderNothing,} from 'recompose'
import {ExpandablePanel} from 'views/AppLocals/custom/AdvancedFormGroup'
import EntityList from 'views/AppLocals/EntityList'
import {HostsSortBy} from 'views/AppLocals/factory/createEntitySortBy'
import {bindQueryParams} from 'views/AppLocals/functions/routerHelper'
import usePaginationHelper from 'views/AppLocals/hooks/usePaginationHelper'
import {renderHost} from 'views/AppLocals/Host/functions/renderHost'
import HostContext, {HostProvider} from 'views/AppLocals/Host/HostContext'
import ListHeader from 'views/AppLocals/Templates/items/ListHeader'
import {NullAsDefault, renderIf} from 'views/Shared'
import WorkspaceContext from '../WorkspaceContext';
import HostsAdvancedFilter from './HostsAdvancedFilter'
import {useRouteSearchParam} from "../../../envs/_current/history";
import {DelayRender} from "../../Shared/components/DelayRender";
import LoadingBlock from "../../Loading/LoadingBlock";
import {AddHostModalContent} from "../../AppLocals/Host/components/AddHostModal";
import {BsCaretRightFill} from "react-icons/bs";

const ExpandContentWrapper = ({children}) => (
    <div className="flex flex-col divider-y divider-gray-200 list-item-workspace">
        {children}
    </div>
)

const ExpandWrapper = ({children}) => (
    <div className="border border-color-50 hover:border-secondary-500 background hover:shadow-md rounded-xl">
        {children}
    </div>
)

const renderExpandHeader = ({count} = {}) => ({title, onClick, expanded}) => {
    return renderIf(
        count,
        <Translate>
            {(t) => (
                <div
                    className={classNames(
                        'px-3 py-2 flex items-center gap-2 transition-all duration-300 cursor-pointer',
                        !!expanded ?
                            'text-secondary-600 bg-secondary-50 rounded-t-xl' :
                            'text-gray-600 hover:text-secondary hover:bg-secondary-50 rounded-xl',
                    )}
                    onClick={onClick}>
                    <BsCaretRightFill size={14} style={{ transform: !!expanded ? 'rotate(90deg)' : '', transition: 'transform 0.3s' }}/>
                    <span className="text-sm font-medium">{t(title)}</span>
                    <span className="text-sm font-semibold">{`(${count})`}</span>
                </div>
            )}
        </Translate>
    )
}

const renderCollapsedContent = (child) => (
    <div
        style={{
            visibility: 'hidden',
            maxHeight: 0,
        }}>
        {child}
    </div>
)

const GoverningOrganizationPendingList = ({refreshToken}) => {
    const [isToggle, toggle] = useToggle()

    const {container} = useContext(HostContext)

    const [id, prop] = [getId(container), getType(container)]

    const renderWrap = useCallback(
        (children, __, count) => (
            <ExpandablePanel
                onClick={toggle}
                expanded={isToggle}
                title="pending list"
                ContentWrapper={ExpandContentWrapper}
                Header={renderExpandHeader({count})}
                Wrapper={count ? ExpandWrapper : undefined}
                renderCollapsedContent={renderCollapsedContent}>
                {children}
            </ExpandablePanel>
        ),
        [isToggle]
    )

    return (
        <EntityList
            key={refreshToken}
            values={{
                request_status: -1,
            }}
            renderItem={renderHost({
                request_status: -1,
            })}
            renderWrap={renderWrap}
            RenderEntity={React.Fragment}
            apiInfo={host_getsbyOwner_api}
            query={bindQueryParams([{id}, {prop}])}
        />
    )
}

export const GoverningOrganizationList = ({
                                              Header = ListHeader,
                                              Wrapper = 'div',
                                              filter_actions = {
                                                  sortBy: 'sort-by',
                                                  keyword: 'keyword',
                                                  status: 'status',
                                                  host_type: 'host-type',
                                              },
                                          }) => {
    const t = useTranslate()

    const history = useHistory()

    const location = useLocation()

    const {container} = useContext(HostContext)

    const {current} = useContext(NavigationContext)

    const [refreshKey, setRefreshKey] = useState()
    const refreshToken = useMemo(
        () =>
            JSON.stringify({
                token: _.get(location.state, 'refreshToken'),
                dependencies: [current],
                refreshKey,
            }),
        [current, refreshKey, location.state]
    )

    const [action, setAction] = useState({
        type: undefined,
        value: undefined,
    })

    const onCancel = () => {
        setAction({})
    }
    const onRefresh = () => {
        setRefreshKey(Date.now())
    }
    const onSuccess = () => {
        setRefreshKey(Date.now())
        onCancel()
    }

    const [id, prop] = [getId(container), getType(container)]

    const status = useRouteSearchParam(filter_actions.status)

    const host_type = useRouteSearchParam(filter_actions.host_type)

    const sortBy = useRouteSearchParam(filter_actions.sortBy)

    const [pager_widget] = usePaginationHelper({
        onInit: ({onSortChange = NullAsDefault, onFilterChange = NullAsDefault}) => {
            onFilterChange({
                status,
                host_type,
            })
            onSortChange(sortBy)
        },
        pagerInfo: {
            apiInfo: host_getsbyOwner_api,
            query: bindQueryParams([{id}, {prop,},]),
            RenderEntity: React.Fragment,
            PaginationMeta: NullAsDefault,
            renderItem: renderHost({
                request_status: 1,
            }),
            renderWrap: (child) => (
                <div className="mt-2 flex flex-col divide-y divide-gray-200 list-item-workspace">
                    {child}
                </div>
            ),
        },
        withValues: (values) => ({
            ...values,
            request_status: 1,
        }),
        withKey: ({sortBy, keyword, filterBy}) =>
            [id, sortBy, keyword, JSON.stringify(filterBy), refreshToken].join('/'),
        filter_params: {
            owner_id: id,
            owner_type: prop,
        },
        query_params: filter_actions,
        dependencies: [id],
        sortHeader: t('list of co-hosting'),
        SortByWidget: HostsSortBy,
        AdvancedFilter: HostsAdvancedFilter,
        renderHeader: ([searchBar, filterBar]) => (
            <div className="flex flex-col gap-4">
                <div className="mb-2 flex flex-col md:flex-row md:items-center gap-3">
                    <div className="flex flex-col flex-1">
                        <h2 className="font-bold text-xl text-gray-800 tracking-wide">
                            {t('governing organizations')}
                        </h2>
                        <div className="mt-1 w-20 h-1 rounded-full bg-gray-400"/>
                    </div>
                    <Button
                        color="primary" variant="solid"
                        className="font-semibold rounded-lg no-border"
                        onClick={() => {
                            setAction({type: "ADD_HOST", value: {id, prop}})
                        }}>
                        {t('create')}
                    </Button>
                </div>
                <GoverningOrganizationPendingList refreshToken={refreshToken}/>
                {filterBar}
                {searchBar}
            </div>
        ),
    })

    const modal = useMemo(() => {
        let Content = NullAsDefault
        let Wrapper = ({children}) => children({initialValues: {}})
        let params = {}
        let modal_params = {}
        switch (action.type) {
            case "ADD_HOST":
                params = {
                    ...action.value
                }
                modal_params = {
                    width: 740,
                }
                Content = AddHostModalContent
                break
            default:
                break
        }

        return (
            <Modal
                className="custom-modal"
                footer={null}
                onCancel={onCancel}
                open={action.type}
                destroyOnHidden={true}
                {...modal_params}>
                <DelayRender lazy={true}>
                    <Wrapper>
                        {({isLoading, initialValues}) => {
                            if (!!isLoading) {
                                return <LoadingBlock/>
                            }
                            return (
                                <Content
                                    {...{
                                        onCancel,
                                        item: action.value,
                                    }}
                                    {...params}
                                />
                            )
                        }}
                    </Wrapper>
                </DelayRender>
            </Modal>
        )
    }, [action])

    return (
        <Wrapper className="flex flex-col gap-3">
            {pager_widget}
            {modal}
            <div className="h-16"/>
        </Wrapper>
    )
}

export default compose(
    fromRenderProps(WorkspaceContext.Consumer, ({organization}) => ({
        container: organization,
    })),
    branch(({container}) => !!!getId(container), renderNothing),
    pure
)(
    nest(
        ({container, children}) => (
            <HostProvider
                container={container}
                autoRefreshKey="refreshToken">
                {children}
            </HostProvider>
        ),
        GoverningOrganizationList
    )
)
